import { gql } from '@apollo/client'
import { client } from '../client';


const CHECK_AUTH_CODE_MUTATION = gql`
  mutation Mutation($authCode: String!, $phoneNumber: String, $transportationId: Int) {
    checkAuthCode(authCode: $authCode, phoneNumber: $phoneNumber, transportationId: $transportationId)
  }
`

interface CheckAuthCodeData {
  checkAuthCode: boolean
}

interface CheckAuthCodeVars {
  authCode: string,
  transportationId?: number,
  phoneNumber?: string,
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const checkAuthCode = (args: CheckAuthCodeVars) => {
  return client.mutate<CheckAuthCodeData, CheckAuthCodeVars>({
    mutation: CHECK_AUTH_CODE_MUTATION,
    variables: args,
  })
}
